import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultMemberFormDateOfBirthFieldConfig = {
    mask: undefined
};
export const memberFormDateOfBirthFieldConfigValidator = Validator.object({
    mask: Validator.optional(nonEmptyStringValidator)
});
